export enum ELD_DRIVER_STATUS {
  EMPTY = 0,
  OFF,
  SB,
  D,
  ON,
  OFF_PC,
  ON_YM,
}

export enum DUTY_STATUS {
  EMPTY = '',
  OFF_DUTY = 'OFF_DUTY',
  SLEEPER_BERTH = 'SLEEPER_BERTH',
  DRIVING = 'DRIVING',
  ON_DUTY_NOT_DRIVING = 'ON_DUTY_NOT_DRIVING',
  OFF_DUTY_PERSONAL_CONVEYANCE = 'OFF_DUTY_PERSONAL_CONVEYANCE',
  ON_DUTY_YARD_MOVE = 'ON_DUTY_YARD_MOVE',
}

export const dutyStatusByEldStatus = {
  [ELD_DRIVER_STATUS.EMPTY]: DUTY_STATUS.EMPTY,
  [ELD_DRIVER_STATUS.OFF]: DUTY_STATUS.OFF_DUTY,
  [ELD_DRIVER_STATUS.SB]: DUTY_STATUS.SLEEPER_BERTH,
  [ELD_DRIVER_STATUS.D]: DUTY_STATUS.DRIVING,
  [ELD_DRIVER_STATUS.ON]: DUTY_STATUS.ON_DUTY_NOT_DRIVING,
  [ELD_DRIVER_STATUS.OFF_PC]: DUTY_STATUS.OFF_DUTY_PERSONAL_CONVEYANCE,
  [ELD_DRIVER_STATUS.ON_YM]: DUTY_STATUS.ON_DUTY_YARD_MOVE,
};
export enum EXCEPTION_STATUS {
  AD = 1,
  SH,
}

export enum EXCEPTION_TYPE {
  ADVERSE_DRIVING = 'ADVERSE_CONDITIONS_EXCEPTION_CODE',
  SIXTEEN_HOUR = 'SIXTEEN_HOUR_EXCEPTION_CODE',
}

export const exceptionTypeByExceptionStatus = {
  [EXCEPTION_STATUS.AD]: EXCEPTION_TYPE.ADVERSE_DRIVING,
  [EXCEPTION_STATUS.SH]: EXCEPTION_TYPE.SIXTEEN_HOUR,
};

export const exceptionStatusByExceptionType = {
  [EXCEPTION_TYPE.ADVERSE_DRIVING]: EXCEPTION_STATUS.AD,
  [EXCEPTION_TYPE.SIXTEEN_HOUR]: EXCEPTION_STATUS.SH,
};

export enum DUTY_TYPE {
  OFF = 'OFF',
  ON = 'ON',
  SB = 'SB',
  AD = 'AD',
  SH = '16',
}

export const ELD_DRIVER_STATUS_REVERSE = ['', 'off', 'sb', 'd', 'on', 'off', 'on', 'v'];
export const ELD_DRIVER_STATUS_TEXT = [
  '',
  'Off Duty',
  'Sleeper Berth',
  'Driving',
  'On Duty',
  'Off Duty',
  'On Duty',
  'V',
];

export const statusToString = (status: number): string =>
  ELD_DRIVER_STATUS_REVERSE[status].toUpperCase();

export const US_ELD_STANDARD = 'us70hour';
export const SHORT_HAUL = 'shortHaulNoBreak';
export const TEXAS_70_HOUR = 'texas70Hour';
export const SHORT_HAUL_PASSENGER = 'shortHaulPassenger';
export const CAN_SOUTH_CYCLE_ONE = 'CAN_SOUTH_CYCLE_ONE';
export const CALIFORNIA_INTRASTATE_PROPERTY = 'CALIFORNIA_INTRASTATE_PROPERTY';
export const CALIFORNIA_INTRASTATE_PASSENGER = 'CALIFORNIA_INTRASTATE_PASSENGER';
export const EXEMPT_DRIVER = 'EXEMPT_DRIVER';
export const USA_PROPERTY_60_7_NO_SLEEPER = 'USA_PROPERTY_60_7_NO_SLEEPER';
export const USA_PROPERTY_70_8_NO_SLEEPER = 'USA_PROPERTY_70_8_NO_SLEEPER';
export const USA_PROPERTY_70_8 = 'USA_PROPERTY_70_8';
export const TEXAS_INTRASTATE_PROPERTY = 'TEXAS_INTRASTATE_PROPERTY';

export const DUTY_STATUSES = {
  OFF_DUTY: 'OFF_DUTY',
  SLEEPER_BERTH: 'SLEEPER_BERTH',
  DRIVING: 'DRIVING',
  ON_DUTY_NOT_DRIVING: 'ON_DUTY_NOT_DRIVING',
  OFF_DUTY_PERSONAL_CONVEYANCE: 'OFF_DUTY_PERSONAL_CONVEYANCE',
  ON_DUTY_YARD_MOVE: 'ON_DUTY_YARD_MOVE',
};

export const RULESET_NAMES: { [key: string]: string } = {
  US_ELD_STANDARD: 'USA Property (70hr / 8day)',
  SHORT_HAUL: 'USA Short Haul Property',
  SHORT_HAUL_PASSENGER: 'USA Short Haul Passenger',
  TEXAS_70_HOUR: 'Texas Intrastate Property(70hr / 7day)',
  CALIFORNIA_INTRASTATE_PROPERTY: 'California Intrastate Property (80hr / 8day)',
  CALIFORNIA_INTRASTATE_PASSENGER: 'California Intrastate Passenger (80hr / 8day)',
  CAN_SOUTH_CYCLE_ONE: 'Canada South - Cycle 1 (70hr / 7day)',
  USA_PROPERTY_60_7_NO_SLEEPER: 'USA Property (60hr / 7day) - No Sleeper Split',
  USA_PROPERTY_70_8_NO_SLEEPER: 'USA Property (70hr / 8day) - No Sleeper Split',
  USA_PROPERTY_70_8: 'USA Property (70hr / 8day) - With Sleeper Split',
  TEXAS_INTRASTATE_PROPERTY: 'Texas Intrastate Property'
};
